import { defineComponent as _defineComponent } from 'vue'
import { translateLang } from '@/data/i18n/translateLang'
import { computed } from 'vue'

interface ProucePopupState {
  is_produced_orders: boolean
  is_display_mark: boolean
  mark_action: 0 | 1
}
// 获取父组件传递过来的props

export default /*#__PURE__*/_defineComponent({
  __name: 'g-order-production-marking',
  props: {
    isShowOrderMark: { type: Boolean, default: false },
    proucePopupState: { default: () => ({
      is_produced_orders: true,
      is_display_mark: true,
      mark_action: 1,
    }) }
  },
  emits: [
  'update:isShowOrderMark',
  'update:proucePopupState',
  'handleOrderMarkOk',
  'handleOrderMarkCancel',
],
  setup(__props: any, { emit: emits }) {

const props = __props as { isShowOrderMark: boolean, proucePopupState: ProucePopupState }



let proucePopupState = computed({
  get: () => props.proucePopupState,
  set: (value: any) => {
    emits('update:proucePopupState', value)
  },
})
let isShowOrderMark = computed({
  get: () => props.isShowOrderMark,
  set: (value: boolean) => {
    emits('update:isShowOrderMark', value)
  },
})
function handleOrderMarkOk() {
  emits('handleOrderMarkOk')
}
function handleOrderMarkCancel() {
  emits('handleOrderMarkCancel')
}

return { __sfc: true,props, emits, proucePopupState, isShowOrderMark, handleOrderMarkOk, handleOrderMarkCancel, translateLang }
}

})